import React, { useEffect, useState } from 'react'
import { MdEdit, MdDelete } from 'react-icons/md'
import { useRequest } from '../../../hooks/useRequest'
import EditSubscription from '../EditSubscription/EditSubscription'
import classes from './PlanLists.module.css'

export default function PlanLists() {
    const { handleFetch } = useRequest()
    const [plans, setPlans] = useState([])

    const [editFormOpen, setEditFormOpen] = useState(false)
    const [editData, setEditData] = useState(null)

    // Fetch using handleFetch
    const fetchPlans = async () => {
        try {
            const { data, isSuccess } = await handleFetch('v1/subscriptions/', {})

            if (isSuccess) {
                setPlans(data)
            }
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        fetchPlans()
    }, [])

    const handleEdit = (plan) => {
        setEditData(plan)
        setEditFormOpen(true)
    }

    const handleDelete = (id) => {
        console.log('Delete plan:', id)
    }

    return (
        <div className={classes.container}>
            <div className={classes.grid}>
                {plans.map((plan) => (
                    <div key={plan.id} className={classes.card}>
                        <div className={classes.cardHeader}>
                            <h3 className={classes.planName}>{plan.name}</h3>
                            <div className={classes.actions}>
                                <button
                                    onClick={() => handleEdit(plan)}
                                    className={classes.iconButton}
                                    aria-label="Edit plan">
                                    <MdEdit />
                                </button>
                                {/* <button
                                    onClick={() => handleDelete(plan.id)}
                                    className={classes.iconButton}
                                    aria-label="Delete plan">
                                    <MdDelete />
                                </button> */}
                            </div>
                        </div>

                        <div className={classes.pricing}>
                            <div className={classes.priceItem}>
                                <span className={classes.priceLabel}>Monthly:</span>
                                <span className={classes.priceValue}>${plan.price_monthly}</span>
                            </div>
                            <div className={classes.priceItem}>
                                <span className={classes.priceLabel}>Yearly:</span>
                                <span className={classes.priceValue}>${plan.price_yearly}</span>
                            </div>
                        </div>

                        <div className={classes.audience}>
                            <span className={classes.audienceLabel}>Target:</span>
                            <span className={classes.audienceBadge}>{plan.target_audience}</span>
                        </div>

                        <div className={classes.features}>
                            <div className={classes.feature}>
                                <span className={classes.featureLabel}>Product Upload:</span>
                                <span className={classes.featureValue}>{plan.max_product_upload}</span>
                            </div>
                            <div className={classes.feature}>
                                <span className={classes.featureLabel}>Featured Products:</span>
                                <span className={classes.featureValue}>{plan.max_feature_product}</span>
                            </div>
                        </div>

                        <div className={classes.badges}>
                            <div className={classes.textformate}>
                                <div className={classes.badge}>
                                    <span
                                        className={`${classes.badgeIcon} ${plan.verified_badge ? classes.active : ''}`}>
                                        {plan.verified_badge ? '✓' : '✗'}
                                    </span>
                                    <span>Verified Badge</span>
                                </div>
                                <span>{plan.verified_badge ? 'Yes' : 'NO'}</span>
                            </div>

                            <div className={classes.textformate}>
                                <div className={classes.badge}>
                                    <span
                                        className={`${classes.badgeIcon} ${plan.search_ranking ? classes.active : ''}`}>
                                        {plan.search_ranking ? '✓' : '✗'}
                                    </span>
                                    <span>Search Ranking</span>
                                </div>
                                <span>{plan.search_ranking ? 'Yes' : 'NO'}</span>
                            </div>

                            <div className={classes.textformate}>
                                <div className={classes.badge}>
                                    <span
                                        className={`${classes.badgeIcon} ${
                                            plan.dedicated_support ? classes.active : ''
                                        }`}>
                                        {plan.dedicated_support ? '✓' : '✗'}
                                    </span>
                                    <span>Dedicated Support</span>
                                </div>
                                <span>{plan.dedicated_support ? 'Yes' : 'NO'}</span>
                            </div>
                        </div>
                        {/* DESCRIPTION ADDED HERE */}
                        {/* {plan.description && <p className={classes.description}>{plan.description}</p>} */}
                    </div>
                ))}
            </div>

            {/* EDIT MODAL */}
            {editFormOpen && (
                <EditSubscription form={editFormOpen} setForm={setEditFormOpen} plan={editData} refresh={fetchPlans} />
            )}
        </div>
    )
}
